var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stripe-checkout',{ref:"checkoutRef",attrs:{"pk":_vm.publishableKey,"session-id":_vm.sessionId}},[_c('template',{slot:"checkout-button"},[_vm._t("paymentbtn",[_c('button',{on:{"click":_vm.checkout}},[_vm._v("Purchase!")])])],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }